// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r6-2";
export var chatLink = "_r6-0";
export var chatText = "_r6-1";